import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Typography } from '@mui/material';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { CircularProgress, Grid } from '@mui/material';
import authStyles from '../../authStyles';
import { CLASS_GROUP_DESCRIPTION_MAXIMUM_LENGTH } from '../../../../constants/assets';

const schema = Yup.object({
    groupName: Yup.string().required(
        'Please enter the name of the group.'
    ),
    groupDescription: Yup.string().required(
        'Please enter the description of the group.'
    )
});

const GroupDialog = ({ onClose, onSuccess, capTableActions }) => {

    const classes = authStyles();

    const initialValues = {
        groupName: '',
        groupDescription: '',
    };

    const submit = (values, { setSubmitting }) => {
        capTableActions.addShareGroup(
            {
                name: values.groupName,
                description: values.groupDescription,
            },
            setSubmitting,
            onSuccess
        )
    };

    return (
        <Dialog
            maxWidth="sm"
            fullWidth
            open={true}
            onBackdropClick={onClose}
        >
            <DialogTitle className={classes.dialogTitle}>
                New Asset
                <br />
            </DialogTitle>
            <DialogContent>
                <Grid container>
                    <Grid item xs={12} md={12}>
                        <Formik
                            initialValues={initialValues}
                            validationSchema={schema}
                            onSubmit={submit}
                        >
                            {({ errors, touched, isSubmitting }) => (
                                <Form
                                    className={classes.form}
                                    noValidate
                                >
                                    <Grid>
                                        <Field
                                            type="text"
                                            label="Name"
                                            name='groupName'
                                            required
                                            fullWidth
                                            placeholder={
                                                'Distributed Assets'
                                            }
                                            render={({ field }) => (
                                                <TextField
                                                    {...field}
                                                    label="Name"
                                                    variant="outlined"
                                                    fullWidth
                                                    margin="normal"
                                                />
                                            )}
                                        />
                                        { errors.groupName && touched.groupName && (
                                            <Typography variant="body2" color="error" style={{ marginTop: 5 }}>
                                                {errors.groupName}
                                            </Typography>
                                        )}
                                        <Field
                                            type="text"
                                            label="Description"
                                            name='groupDescription'
                                            variant="outlined"
                                            required
                                            placeholder={
                                                'Flag assets that have been distributed'
                                            }
                                            inputProps={{
                                                maxLength: CLASS_GROUP_DESCRIPTION_MAXIMUM_LENGTH,
                                            }}
                                            render={({ field }) => (
                                                <TextField
                                                    {...field}
                                                    label="Description"
                                                    variant="outlined"
                                                    fullWidth
                                                    margin="normal"
                                                />
                                            )}
                                        />
                                        { errors.groupDescription && touched.groupDescription && (
                                            <Typography variant="body2" color="error" style={{ marginTop: 5 }}>
                                                {errors.groupDescription}
                                            </Typography>
                                        )}
                                    </Grid>

                                    <DialogActions
                                        className={classes.actions}
                                    >
                                        <Button
                                            color="secondary"
                                            variant="outlined"
                                            className={
                                                classes.secondaryButtonLabel
                                            }
                                            onClick={() => {
                                                onClose();
                                            }}
                                        >
                                            Cancel
                                        </Button>
                                        <Button
                                            type="submit"
                                            color="primary"
                                            variant="outlined"
                                            className={
                                                classes.buttonLabel
                                            }
                                            disabled={isSubmitting}
                                        >
                                            {!isSubmitting ? (
                                                <span>Save</span>
                                            ) : (
                                                <CircularProgress
                                                    size={24}
                                                />
                                            )}
                                        </Button>
                                    </DialogActions>
                                </Form>
                            )}
                        </Formik>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

export default GroupDialog;